<dialog #modal
        class="root-container"
        [ngClass]="{'show-backdrop': options().showBackDrop ?? true}"
        [style.max-width.px]="options().maxWidth">
    @if (options().hasCloseIcon) {
      <i class="bi bi-x-lg close-button" (click)="onDismiss()"></i>
    }

  <modal-icon [preset]="options().iconPreset" [bi_icon]="options().bi_icon" [type]="options().iconType ?? 'default'" />
  <div class="title">{{ options().title }}</div>
  <div class="sub-title">{{ options().subTitle }}</div>
  <div class="body">
    <ng-content></ng-content>
  </div>
  <div class="button-container">
    @if (options().negativeText){
      <button-component [text]="options().negativeText ?? ''"
                        [type]="options().negativeType ?? 'secondary'"
                        [disabled]="options().negativeDisabled ?? false"
                        (click)="executeAction('negative')"/>
    }

    @if (options().positiveText){
      <button-component [text]="options().positiveText ?? ''"
                        [type]="options().positiveType ?? 'primary'"
                        [disabled]="options().positiveDisabled ?? false"
                        (click)="executeAction('positive')"/>
    }
  </div>
</dialog>
